import { account } from './account';
import { arrowLeft } from './arrowLeft';
import { arrowRight } from './arrowRight';
import { bag } from './bag';
import { basket } from './basket';
import { breitling } from './breitling';
import { burgerMenu } from './burgerMenu';
import { calendar } from './calendar';
import { check } from './check';
import { chevronDown } from './chevronDown';
import { chevronLeft } from './chevronLeft';
import { chevronRight } from './chevronRight';
import { chevronUp } from './chevronUp';
import { close } from './close';
import { eye } from './eye';
import { eyeClosed } from './eyeClosed';
import { facebook } from './facebook';
import { globe } from './globe';
import { heart } from './heart';
import { heartOutline } from './heartOutline';
import { infoBadge } from './infoBadge';
import { instagram } from './instagram';
import { international } from './international';
import { language } from './language';
import { line } from './line';
import { location } from './location';
import { locationOutline } from './locationOutline';
import { longArrow } from './longArrow';
import { mail } from './mail';
import { minus } from './minus';
import { newBadge } from './newBadge';
import { pinterest } from './pinterest';
import { plus } from './plus';
import { remove } from './remove';
import { search } from './search';
import { stava } from './stava';
import { telephoneCall } from './telephoneCall';
import { tiktok } from './tiktok';
import { twitter } from './twitter';
import { twitterX } from './twitterX';
import { upload } from './upload';
import { user } from './user';
import { youtube } from './youtube';

export const iconSet = {
  account,
  arrowLeft,
  arrowRight,
  check,
  bag,
  basket,
  burgerMenu,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  close,
  facebook,
  globe,
  heart,
  heartOutline,
  infoBadge,
  international,
  instagram,
  minus,
  newBadge,
  pinterest,
  plus,
  search,
  stava,
  telephoneCall,
  tiktok,
  twitter,
  twitterX,
  user,
  youtube,
  location,
  locationOutline,
  language,
  eye,
  eyeClosed,
  breitling,
  calendar,
  mail,
  upload,
  remove,
  longArrow,
  line,
};
